import { CurrencyCode } from '@/utilities/price';

export const Language = {
  Slovak: 'sk',
  Czech: 'cs',
} as const;

export type Language = (typeof Language)[keyof typeof Language];

export function getCurrencyCode(lang: Language): CurrencyCode {
  switch (lang) {
    case Language.Slovak:
      return CurrencyCode.EUR;
    case Language.Czech:
      return CurrencyCode.CZK;
    default: {
      const _exhaustiveCheck: never = lang;
      throw new Error(`Unsupported language: ${lang}`);
    }
  }
}
